export const GET_FOLLOWUP_REMINDER_LIST = "GET_FOLLOWUP_REMINDER_LIST"
export const GET_FOLLOWUP_REMINDER_LIST_SUCCESS = "GET_FOLLOWUP_REMINDER_LIST_SUCCESS"
export const GET_FOLLOWUP_REMINDER_LIST_FAIL = "GET_FOLLOWUP_REMINDER_LIST_FAIL"

// New action types for updating reminder
export const UPDATE_FOLLOWUP_REMINDER = "UPDATE_FOLLOWUP_REMINDER"
export const UPDATE_FOLLOWUP_REMINDER_SUCCESS = "UPDATE_FOLLOWUP_REMINDER_SUCCESS"
export const UPDATE_FOLLOWUP_REMINDER_FAIL = "UPDATE_FOLLOWUP_REMINDER_FAIL"
